import {
    GET_DOWNLOAD_PENGURUS_PUSAT,
    GET_DOWNLOAD_PENGURUS_PUSAT_SUCCESS,
    GET_DOWNLOAD_PENGURUS_PUSAT_FAIL,
    GET_DOWNLOAD_PENGURUS_PROVINSI,
    GET_DOWNLOAD_PENGURUS_PROVINSI_SUCCESS,
    GET_DOWNLOAD_PENGURUS_PROVINSI_FAIL,
    GET_DOWNLOAD_PENGURUS_KABKOT,
    GET_DOWNLOAD_PENGURUS_KABKOT_SUCCESS,
    GET_DOWNLOAD_PENGURUS_KABKOT_FAIL,
    GET_DOWNLOAD_PENGURUS_KECAMATAN,
    GET_DOWNLOAD_PENGURUS_KECAMATAN_SUCCESS,
    GET_DOWNLOAD_PENGURUS_KECAMATAN_FAIL,

    GET_DOWNLOAD_REKAP_PENGURUS_PUSAT,
    GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_SUCCESS,
    GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_FAIL,
    GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI,
    GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_SUCCESS,
    GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_FAIL,
    GET_DOWNLOAD_REKAP_PENGURUS_KABKOT,
    GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_SUCCESS,
    GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_FAIL,

    GET_DOWNLOAD_REKAP_ANGGOTA,
    GET_DOWNLOAD_REKAP_ANGGOTA_SUCCESS,
    GET_DOWNLOAD_REKAP_ANGGOTA_FAIL,
    GET_DOWNLOAD_DAFTAR_ANGGOTA,
    GET_DOWNLOAD_DAFTAR_ANGGOTA_SUCCESS,
    GET_DOWNLOAD_DAFTAR_ANGGOTA_FAIL,
  } from "./actionTypes";
  import { API } from "../../API/api";
  
  // get exco table
  export const getDownloadPengurusPusat = () => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_PENGURUS_PUSAT,
    });
  
    const request = API.getDownloadPengurusPusat();
    return request.then(
      (response) => dispatch(getDownloadPengurusPusatSuccess(response.data)),
      (err) => dispatch(getDownloadPengurusPusatFail(err))
    );
  };
  
  export const getDownloadPengurusPusatSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_PUSAT_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadPengurusPusatFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_PUSAT_FAIL,
      payload: data,
    });
  };

	export const getDownloadPengurusProvinsi = (order_by,order_type,id_provinsi) => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_PENGURUS_PROVINSI,
    });
  
    const request = API.getDownloadPengurusProvinsi(order_by,order_type,id_provinsi);
    return request.then(
      (response) => dispatch(getDownloadPengurusProvinsiSuccess(response.data)),
      (err) => dispatch(getDownloadPengurusProvinsiFail(err))
    );
  };
  
  export const getDownloadPengurusProvinsiSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_PROVINSI_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadPengurusProvinsiFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_PROVINSI_FAIL,
      payload: data,
    });
  };

	export const getDownloadPengurusKabkot = (order_by,order_type,id_provinsi,id_kabkot) => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_PENGURUS_KABKOT,
    });
  
    const request = API.getDownloadPengurusKabkot(order_by,order_type,id_provinsi,id_kabkot);
    return request.then(
      (response) => dispatch(getDownloadPengurusKabkotSuccess(response.data)),
      (err) => dispatch(getDownloadPengurusKabkotFail(err))
    );
  };
  
  export const getDownloadPengurusKabkotSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_KABKOT_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadPengurusKabkotFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_KABKOT_FAIL,
      payload: data,
    });
  };

  export const getDownloadPengurusKecamatan = (order_by,order_type,id_provinsi,id_kabkot) => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_PENGURUS_KECAMATAN,
    });
  
    const request = API.getDownloadPengurusKecamatan(order_by,order_type,id_provinsi,id_kabkot);
    return request.then(
      (response) => dispatch(getDownloadPengurusKecamatanSuccess(response.data)),
      (err) => dispatch(getDownloadPengurusKecamatanFail(err))
    );
  };
  
  export const getDownloadPengurusKecamatanSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_KECAMATAN_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadPengurusKecamatanFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_PENGURUS_KECAMATAN_FAIL,
      payload: data,
    });
  };

	export const getDownloadRekapPengurusPusat = () => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_PUSAT,
    });
  
    const request = API.getDownloadRekapPengurusPusat();
    return request.then(
      (response) => dispatch(getDownloadRekapPengurusPusatSuccess(response.data)),
      (err) => dispatch(getDownloadRekapPengurusPusatFail(err))
    );
  };
  
  export const getDownloadRekapPengurusPusatSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadRekapPengurusPusatFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_FAIL,
      payload: data,
    });
  };

	export const getDownloadRekapPengurusProvinsi = () => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI,
    });
  
    const request = API.getDownloadRekapPengurusProvinsi();
    return request.then(
      (response) => dispatch(getDownloadRekapPengurusProvinsiSuccess(response.data)),
      (err) => dispatch(getDownloadRekapPengurusProvinsiFail(err))
    );
  };
  
  export const getDownloadRekapPengurusProvinsiSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadRekapPengurusProvinsiFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_FAIL,
      payload: data,
    });
  };

	export const getDownloadRekapPengurusKabkot = () => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_KABKOT,
    });
  
    const request = API.getDownloadRekapPengurusKabkot();
    return request.then(
      (response) => dispatch(getDownloadRekapPengurusKabkotSuccess(response.data)),
      (err) => dispatch(getDownloadRekapPengurusKabkotFail(err))
    );
  };
  
  export const getDownloadRekapPengurusKabkotSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadRekapPengurusKabkotFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_FAIL,
      payload: data,
    });
  };

  export const getDownloadRekapAnggota = (order_by,order_type,id_provinsi,id_kabkot) => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_REKAP_ANGGOTA,
    });
  
    const request = API.getDownloadRekapAnggota(order_by,order_type,id_provinsi,id_kabkot);
    return request.then(
      (response) => dispatch(getDownloadRekapAnggotaSuccess(response.data)),
      (err) => dispatch(getDownloadRekapAnggotaFail(err))
    );
  };
  
  export const getDownloadRekapAnggotaSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_ANGGOTA_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadRekapAnggotaFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_REKAP_ANGGOTA_FAIL,
      payload: data,
    });
  };

  export const getDownloadDaftarAnggota = (order_by,order_type,id_provinsi,id_kabkot) => (dispatch) => {
    dispatch({
      type: GET_DOWNLOAD_DAFTAR_ANGGOTA,
    });
  
    const request = API.getDownloadDaftarAnggota(order_by,order_type,id_provinsi,id_kabkot);
    return request.then(
      (response) => dispatch(getDownloadDaftarAnggotaSuccess(response.data)),
      (err) => dispatch(getDownloadDaftarAnggotaFail(err))
    );
  };
  
  export const getDownloadDaftarAnggotaSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_DAFTAR_ANGGOTA_SUCCESS,
      payload: data,
    });
  };
  
  export const getDownloadDaftarAnggotaFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOWNLOAD_DAFTAR_ANGGOTA_FAIL,
      payload: data,
    });
  };